export default "__VITE_ASSET__BU9i$1bC__"